import { notification } from 'ant-design-vue'

export const APP_UPDATED_NOTIFICATION_KEY = 'app-updated-version'
export const APP_UPDATED_NOTIFICATION_MESSAGE =
  "You were using an outdated version of the ePeople app, so we updated it to make sure you don't fall behind."

export const showServerUpdateNotification = () => {
  notification.info({
    key: APP_UPDATED_NOTIFICATION_KEY,
    message: 'Update!',
    description: APP_UPDATED_NOTIFICATION_MESSAGE
  })
}
